(function () {
  'use strict';

  const MIN_DESCRIPTION_LENGTH = 250;
  const TOGGLE_LABEL_MORE = 'Read more';
  const TOGGLE_LABEL_LESS = 'Read less';

  function initCollectionHero() {
    const main = document.querySelector('main');
    if (!main) return;

    const template = main.getAttribute('data-template');
    if (!template || !template.startsWith('collection')) return;

    const heroSection = main.querySelector('.section-wrapper:first-child');
    if (!heroSection) return;

    heroSection.classList.add('collection-hero');

    const inner = heroSection.querySelector('.section-content-wrapper');
    if (inner) inner.classList.add('collection-hero__inner');

    const description = heroSection.querySelector('.text-block.rte');
    if (!description) return;

    description.classList.add('collection-hero__description', 'collection__description');

    const plainText = description.textContent.trim();
    if (plainText.length < MIN_DESCRIPTION_LENGTH) return;

    const content = document.createElement('div');
    content.className = 'collection-description__content';

    while (description.firstChild) {
      content.appendChild(description.firstChild);
    }

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'collection-description__toggle';
    toggle.textContent = TOGGLE_LABEL_MORE;
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', () => {
      const isExpanded = content.classList.toggle('is-expanded');
      toggle.textContent = isExpanded ? TOGGLE_LABEL_LESS : TOGGLE_LABEL_MORE;
      toggle.setAttribute('aria-expanded', String(isExpanded));
    });

    description.appendChild(content);
    description.appendChild(toggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionHero);
  } else {
    initCollectionHero();
  }
})();
